import React from 'react';
import './LibraryStatistics.css';

const LibraryStatistics = () => {
  const statistics = [
    {
      icon: 'fas fa-book',
      number: '44225+',
      label: 'Books',
      description: 'Comprehensive collection across all disciplines',
      color: '#b71c1c'
    },
    {
      icon: 'fas fa-newspaper',
      number: 'Research Journals',
      label: 'Journals',
      description: 'National and international periodicals',
      color: '#1565c0'
    },
    {
      icon: 'fas fa-laptop',
      number: 'Digital Resources',
      label: 'E-Books',
      description: 'Digital books and online resources',
      color: '#2e7d32'
    },
    {
      icon: 'fas fa-database',
      number: 'Audio and Video',
      label: 'Databases',
      description: 'Online databases and digital libraries',
      color: '#f57c00'
    },
    {
      icon: 'fas fa-chair',
      number: 'Study Space',
      label: 'Reading Seats',
      description: 'Comfortable seating arrangements',
      color: '#1976d2'
    }
  ];

  const facilities = [
    {
      title: 'Library Services',
      items: [
        'Book Circulation Service',
        'Reference service / Referral Service',
        'Journals & General magazine section',
        'Newspaper section',
        'Web OPAC / Bibliographic service',
        'Online Access to e-resources',
        'E-VIDYA Digital Library service',
        'Reprographic services',
        'SC/ST Book Bank scheme',
        'National Digital Library Services',
        'RFID-enabled book management',
        'Online Public Access Catalog (OPAC)',
        'Institutional Repository',
        'Digital Library Portal'
      ]
    },
    {
      title: 'Departments',
      items: [
        'Artificial Intelligence & Machine Learning',
        'civil Engineering',
        'Computer Engineering',
        'Electrical and Electronics',
        'Mechanical Engineering',
       
       
        'Biotechnology',
        'Botany',
        'Chemistry',
        'Commerce',
        
        'Computer Science',
        
        'Economics',
        
        'English',
        'Management',
        'Mathematics',
        'Physics',
        'Statistics (OR & SQC)',
        'Telugu',
        'Zoology',
        'Competitive Books',
        'E-Books & E-Journals'
      ]
    }
  ];

  return (
    <section id="library-statistics">
      <div id="stats-container">
        <div id="stats-header">
          <h2 className="stats-title">Library at a Glance</h2>
          <p className="stats-subtitle">Comprehensive statistics showcasing our extensive resources and services</p>
        </div>

        {/* Statistics Cards */}
        <div className="statistics-grid">
          {statistics.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                <i className={stat.icon}></i>
              </div>
              <div className="stat-content">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
                <div className="stat-description">{stat.description}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Facilities Section */}
        <div className="facilities-section">
          <h3 className="facilities-title">Key Facilities & Services</h3>
          <div className="facilities-grid">
            {facilities.map((facility, index) => (
              <div key={index} className="facility-card">
                <div className="facility-header expanded">
                  <h4 className="facility-title">{facility.title}</h4>
                </div>
                <div className="facility-content expanded">
                  <ul className="facility-list">
                    {facility.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="facility-item">
                        <i className="fas fa-check-circle"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>
    </section>
  );
};

export default LibraryStatistics;